import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subscription, BehaviorSubject, throwError, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

// INTERFACES

// SERVICES
import { environment } from '@app/env-service';

import { PricingOverrideInterface } from './../../modules/pricing/interfaces/pricing.interface';

@Injectable({
  providedIn: 'root',
})
export class PricingOverrideService {
  private readonly _loading = new BehaviorSubject<boolean>(<boolean>false);
  private readonly _pricingOverrides = new BehaviorSubject<
    PricingOverrideInterface[]
  >(<PricingOverrideInterface[]>[]);

  loading$ = this._loading.asObservable();
  pricingOverrides$ = this._pricingOverrides.asObservable();

  constructor(private http :HttpClient) {}

  get(params :{ [param :string] :string | string[] }) :Subscription {
    this._loading.next(true);

    return this.http
      .get(`${environment.urlV2}/pricing/price-overrides`, { params })
      .subscribe(
        (response :any) => {
          this._pricingOverrides.next(response.data);
          this._loading.next(false);
        },
        (response :any) => {
          this._loading.next(false);
          throwError(response.error);
        },
      );
  }

  getById(
    id :number,
    params :{ [param :string] :string | string[] },
  ) :Subscription {
    this._loading.next(true);

    return this.http
      .get(`${environment.urlV2}/pricing/price-overrides/${id}`, { params })
      .subscribe(
        (response :any) => {
          this._loading.next(false);
        },
        (response :any) => {
          this._loading.next(false);
          throwError(response.error);
        },
      );
  }

  create(override :{
    price :number;
    rfqId :number;
    priceScheduleTierId :number;
    priceLevelId :number;
  }) :Observable<any> {
    return this.http
      .post(`${environment.urlV2}/pricing/price-overrides`, override)
      .pipe(
        map((response :PricingOverrideInterface) => {
          this._pricingOverrides.next([...this._pricingOverrides.value, response]);

          return response;
        }),
        catchError((response) => {
          return throwError(response.error);
        }),
      );
  }

  update(data :{
    id :number;
    payload :{
      rfqId :number;
      priceScheduleTierId :number;
      priceLevelId :number;
      price :number;
    };
  }) :Observable<any> {
    const { id, payload } = data;

    return this.http
      .put(`${environment.urlV2}/pricing/price-overrides/${id}`, payload)
      .pipe(
        map((response :PricingOverrideInterface) => {
          return response;
        }),
        catchError((response) => {
          return throwError(response.error);
        }),
      );
  }
}
